import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

function loadView(view) {
  return () => import(`../views/${view}.vue`);
}

const routes = [{
    path: "/",
    name: "Home",
    component: loadView("Schedule"),
  },
  {
    path: "/calendar",
    name: "calendar",
    component: loadView("Calendar"),
  },
  {
    path: "/schedule",
    name: "schedule",
    component: loadView("Schedule"),
  },
  {
    path: "/schedule-mobile",
    name: "schedule-mobile",
    component: loadView("ScheduleMobile"),
  },
  {
    path: "/form",
    name: "form",
    component: loadView("Form"),
  },
  {
    path: "/confirm",
    name: "confirm",
    component: loadView("Confirm"),
    props: true,
  },
  {
    path: "/complete",
    name: "complete",
    component: loadView("Complete"),
    props: true,
  },
];

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;